import { FC } from 'react';

import { SecondaryButton, BUTTON_SIZES } from 'ui/button';
import { AiRecommendCopy } from 'ui/icons';

import {
  NBACardContentContainer,
  NBACardContentHeader,
  NBACardContentSubHeader,
  NBACardContentInfoContainer,
  NBARecommendIconContainer,
  NBACardContentColumn,
} from './CampaignNBA.styles';

export interface CampaignNBACardContentProps {
  header: string;
  onActionClick: () => void;
  content: string;
}
export const CampaignNBACardContent: FC<React.PropsWithChildren<CampaignNBACardContentProps>> = ({
  header,
  onActionClick,
  content,
}) => {
  return (
    <NBACardContentContainer data-test="campaigns-nba-card-content">
      <NBACardContentInfoContainer>
        <NBARecommendIconContainer>
          <AiRecommendCopy />
        </NBARecommendIconContainer>
        <NBACardContentColumn>
          <NBACardContentHeader>{header}</NBACardContentHeader>
          <NBACardContentSubHeader>{content}</NBACardContentSubHeader>
        </NBACardContentColumn>
      </NBACardContentInfoContainer>
      <SecondaryButton onClick={onActionClick} size={BUTTON_SIZES.LARGE}>
        Explore
      </SecondaryButton>
    </NBACardContentContainer>
  );
};
